
<template>
  <div class="box" v-if="show">
    <div class="info">
      <div class="close" @click="close">
        <i class="icon icon-close"></i>
      </div>
      <p><i class="icon icon-alert"></i><span>{{desc}}</span></p>
    </div>
  </div>
</template>

<script>

  

  export default {
    props: {
      alertString: String,
    },
    data(){
      return {
        show:false,
        desc:'',
      }
    },
    watch:{
    },
    methods: {
      alert(desc){
        this.desc = desc;
        this.show = true;
      },
      close(){
        this.desc = '';
        this.show = false;
      }
    },
  }
</script>

<style lang="scss" scoped>
  .box{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .info{
      position: relative;
      display: inline-block;
      background-color: #000;
      border: 1px solid #888;
      width: 5rem;
      min-height: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      .close{
        position: absolute;
        right: 0.05rem;
        top: 0.05rem;
        width: 0.3rem;
        height: 0.3rem;
        .icon-close{
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      p{
        color: #fff;
        font-size: 0.3rem;

        .icon-alert{
          vertical-align: middle;
          $size: 0.3rem;
          width: $size;
          height: $size * 0.95;
        }
        span{
          vertical-align: middle;
        }
      }
    }
  }
</style>
